module.exports = __webpack_public_path__ + "img/sample-ktp2.69251ae0.png";